export const Role = {
  OWNER: 'OWNER',
  MANAGER: 'MANAGER',
  ADMIN: 'ADMIN',
  COUNTER_AGENT: 'COUNTER_AGENT',
  WAREHOUSE_KEEPER: 'WAREHOUSE_KEEPER',
  POLYVALENT: 'POLYVALENT',
  PURCHASER: 'PURCHASER',
  ACCOUNTING: 'ACCOUNTING',
  B2B_OWNER: 'B2B_OWNER',
  B2B_BUYER: 'B2B_BUYER',
  B2B_VIEWER: 'B2B_VIEWER',
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export const INTERNAL_ROLES: Role[] = [
  Role.OWNER,
  Role.MANAGER,
  Role.ADMIN,
  Role.COUNTER_AGENT,
  Role.WAREHOUSE_KEEPER,
  Role.POLYVALENT,
  Role.PURCHASER,
  Role.ACCOUNTING,
];

export const B2B_ROLES: Role[] = [Role.B2B_OWNER, Role.B2B_BUYER, Role.B2B_VIEWER];
